import { Link } from 'react-router-dom';
import SectionHeader from './SectionHeader';
import { CUSTOM_SOFTWARE } from '../config/site';

export default function CustomSoftwareSection({ compact = false, creative = false }) {
  return (
    <section
      className={`section custom-software${compact ? ' custom-software--compact' : ''}${creative ? ' custom-software--creative' : ''}`}
    >
      <div className="container custom-software__grid">
        <div className="custom-software__content">
          <SectionHeader
            creative={creative}
            light={creative}
            label={CUSTOM_SOFTWARE.label}
            title={CUSTOM_SOFTWARE.title}
            description={CUSTOM_SOFTWARE.description}
          />
          <p className="custom-software__tagline">{CUSTOM_SOFTWARE.tagline}</p>
          {!compact && (
            <ul className="custom-software__list">
              {CUSTOM_SOFTWARE.offerings.map((item) => (
                <li key={item}>{item}</li>
              ))}
            </ul>
          )}
          <Link to={CUSTOM_SOFTWARE.contactPath} className="btn btn--primary">
            {CUSTOM_SOFTWARE.ctaLabel}
          </Link>
        </div>
        {!compact && (
          <div className={`card custom-software__card${creative ? ' custom-software__panel' : ''}`}>
            <h3>How we partner</h3>
            <p>
              From AI discovery to launch on your cloud — we bring the same rigour we use running eGrahmantree in
              production every day.
            </p>
            <ul className="custom-software__list custom-software__list--card">
              {CUSTOM_SOFTWARE.offerings.map((item) => (
                <li key={item}>{item}</li>
              ))}
            </ul>
            <p className="custom-software__note">
              Share your vision — we respond with a clear, practical plan.
            </p>
          </div>
        )}
      </div>
    </section>
  );
}
